(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairPavilionsController', VirtualFairPavilionsController)

    VirtualFairPavilionsController.$inject = ['VirtualFairService', '$state', 'fairExposByPavilion', 'fairExposByPavilionAdded',  '$stateParams', 'toastr'];


    function VirtualFairPavilionsController(VirtualFairService, $state, fairExposByPavilion, fairExposByPavilionAdded,  $stateParams, toastr) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.expos                        = [];
        vm.expotypes                    = [];
        vm.expoSelected                 = 0;
        vm.selectExpos                  = selectExpos;
        vm.getByFilter                  = getByFilter;
        vm.getPavilions                 = getPavilions;
        vm.goToExpoList                 = goToExpoList;
        vm.isSelected                   = isSelected;
        vm.pavilions                    = [];

        /* @TODO: Extract to own controller Expo list */
        vm.fairExposByPavilion          = fairExposByPavilion;
        vm.fairSponsors                 = vm.fairExposByPavilion.filter((f) => f.is_sponsor === "1");
        vm.fairExpos                    = vm.fairExposByPavilion.filter((f) => f.is_sponsor === "0");
        vm.sponsorsSelected             = [];
        vm.exposSelected                = [];
        vm.tab                          = vm.fairSponsors.length ? 'sponsors' : 'expos';
        vm.tabChange                    = tabChange;
        vm.selectFairExpo               = selectFairExpo;
        vm.flag                         = false;
        vm.saveExpos                    = saveExpos;
        vm.goToList                     = goToList;
        vm.setPosition                  = setPosition;


        vm.logicOptions                 = [
                                            { id: 0, name: 'No' },
                                            { id: 1, name: 'Yes' }
                                        ];

        const addedIds                  = fairExposByPavilionAdded.map(a => a.user_id)
        const totalSponsorsSelected     = vm.fairExposByPavilion.filter(s => (s.is_sponsor === "1" && addedIds.includes(s.user_id))).length

        vm.resultList                   = Object.keys(fairExposByPavilionAdded).length ? fairExposByPavilionAdded.reduce((acc, selected) => {
            const expo = vm.fairExposByPavilion.find(e => e.user_id === selected.user_id)
            acc = {
                ...acc,
                [selected.user_id]: {
                    ...expo,
                    position: expo.is_sponsor === "1" ? Number.parseInt(selected.position) : Number.parseInt(selected.position) - totalSponsorsSelected,
                    type: expo.is_sponsor === "1" ? 'sponsors' : 'expos'
                }
            }
            return acc
        }, {}) : {}
        vm.pavilion                     = {
            id: $stateParams.id,
            sponsor: false,
            expos: vm.resultList
        }

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;
        
        function activate() {
            vm.setPage(1);
            vm.selectExpos();
            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpos () {
            VirtualFairService.getAll().then(function(response){
                vm.expos = response.data;
            });
        }

        function getByFilter () {
            vm.queryFlag = false;
            let query = {};
            query['page'] = vm.page;
            query['virtual_fair_id'] = vm.expoSelected;
            VirtualFairService.getVirtualFairsBySettings(query).then(function(response){
                vm.queryFlag = true;
                vm.virtualfairs = response.data.data;
                // vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
            });
        }

        function getPavilions() {
            let query = {};
            query['virtual_fair_id'] = vm.expoSelected;
            VirtualFairService.getVirtualFairPavilions(query).then(function(response){
                vm.pavilions = response.data;
                vm.totalItems = response.data.length;
            });
        }

        function goToExpoList(pavilionId){
            $state.go("root.virtualfair.pavilions.expos", {id: pavilionId});
        }

        function tabChange(value) {
            vm.tab = value;
        }

        function selectFairExpo(ev, expo){
            ev.stopPropagation()
            if(vm.resultList.hasOwnProperty(expo.user_id)){
                delete vm.resultList[expo.user_id]
            } else {
                vm.resultList[expo.user_id] = {
                    user_id: expo.user_id,
                    position: expo.position,
                    stand_style: expo.stand_style,
                    type: expo.is_sponsor === "1" ? 'sponsors' : 'expos'
                }
            }
            console.log(vm.resultList)
           vm.flag = !!Object.keys(vm.resultList).length
        }

        function isSelected(item){
            if(!vm.resultList.length || !item) return false
            return vm.resultList.some(i =>  (i.user_id === item.user_id))
        }

        function setPosition(item)
        {
           vm.resultList = vm.resultList.map(i => {
               console.log(item)
               if(i.user_id === item.user_id){
                   return item
               }
           })
            console.log(vm.resultList)
        }

        async function saveExpos(){
            const missingPosition = Object.values(vm.resultList).some(expo => expo.position === undefined || expo.position === '')
            if(missingPosition){
                toastr.warning('Missing position. Please fill all positions before saving')
                return
            }

            vm.pavilion.expos = JSON.stringify(vm.resultList)
           const result = await VirtualFairService.saveExpos(vm.pavilion)
            console.log('result status', result.status)
           if(result.status === 200){
               toastr.success('Exhibithors saved!');
               vm.goToList();
           }
        }

        function goToList(){
            $state.go('root.virtualfair.pavilions');
        }
        activate();
    }

})();